<template>
  <div
    style="margin-top: 0px; z-index: 2"
    @click="removeLists"
  >
    <div>
      <div class="filtering">
        <div class="search-toggle">
          <p>{{ $t('SearchBy') }}</p>
          <div>
            <p
              :class="{ active2: searchType === 'variant' }"
              @click="setSearchType('variant')"
            >
              {{ $t('MaterialVariant') }}
            </p>
            <p
              :class="{ active2: searchType === 'name' }"
              @click="setSearchType('name')"
            >
              {{ $t('MaterialName') }}
            </p>
            <p
              :class="{ active2: searchType === 'location' }"
              @click="setSearchType('location')"
            >
              {{ $t('Location') }}
            </p>
          </div>
        </div>

        <div v-if="searchType === 'variant'">
          <div>
            <div class="black">
              <b-icon-search
                v-if="materialVariantName == ''"
                class="search1"
                style="position: absolute; left: 5px; top: 12px"
              />
              <b-icon-x-circle
                v-else-if="materialVariantName != '' && !noSearch"
                class="search1"
                style="position: absolute; right: 20px; top: 12px; cursor: pointer"
                @click="materialVariantName = ''; noSearch = false"
              />
              <input
                v-model="materialVariantName"
                type="text"
                autocomplete="off"
                name="search-box"
                :placeholder="$t('MaterialVariant')"
                :style="getMaterialVariantLocationNameLike.length > 0 && noSearch ? 'border-radius: 8px 8px 0px 0px' : ''"
                @keyup="inputChanged"
                @keydown.down="onArrowDown"
                @keydown.up="onArrowUp"
                @keydown.enter="inputChanged($event)"
              >
            </div>
            <div
              v-if="getMaterialVariantLocationNameLike.length > 0 && noSearch"
              ref="scrollContainer"
              class="dropdrop"
              style="
              display: inline-block;
              overflow: auto;
              position: absolute;
              background: white;
              width: 229px;
              box-shadow: none;"
              :style="getMaterialVariantLocationNameLike.length > 7 ? 'height: 210px' : 'height: auto'"
            >
              <div
                v-for="(item, index) in getMaterialVariantLocationNameLike"
                ref="options" :key="index"
                :class="{ 'is-active': index === arrowCounter }"
                style="cursor: pointer"
                class="search-item"
                @click.stop="searchByVariantName(item.locationName); noSearch = false"
              >
                <p style="margin: 0">
                  {{ item.locationName || '[Error: Missing Display Key]' }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="searchType === 'name'">
          <div class="black">
            <b-icon-search
              v-if="materialName == ''"
              class="search2"
              style="position: absolute; left: 5px; top: 12px"
            />
            <b-icon-x-circle
              v-else-if="materialName != '' && !noSearchTwo"
              class="search1"
              style="position: absolute; right: 20px; top: 12px; cursor: pointer"
              @click="materialName = ''; noSearchTwo = false"
            />
            <input
              v-model="materialName"
              type="text"
              name="search-box"
              :style="getMaterialLocationMaterialNameLike.length > 0 && noSearchTwo ? 'border-radius: 8px 8px 0px 0px' : ''"
              :placeholder="$t('MaterialName')"
              @keyup="inputChanged2"
              @keydown.down="onArrowDown2"
              @keydown.up="onArrowUp2"
              @keydown.enter="inputChanged2($event)"
            >
          </div>
          <div
            v-if="getMaterialLocationMaterialNameLike.length > 0 && noSearchTwo"
            ref="scrollContainer2"
            class="dropdrop"
            style="
            display: inline-block;
            overflow: auto;
            position: absolute;
            background: white;
            width: 229px;
            box-shadow: none;
            "
            :style="getMaterialLocationMaterialNameLike.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(item, index) in getMaterialLocationMaterialNameLike"
              :key="index"
              ref="options2" style="cursor: pointer"
              :class="{ 'is-active': index === arrowCounter2 }"
              class="search-item"
              @click.stop="searchByName(item.locationName); noSearchTwo = false"
            >
              <p style="margin: 0">
                {{ item.locationName || '[Error: Missing Display Key]' }}
              </p>
            </div>
          </div>
        </div>

        <div v-if="searchType === 'location'">
          <div class="black">
            <b-icon-search
              v-if="locationName == ''"
              class="search2"
              style="position: absolute; left: 5px; top: 12px"
            />
            <b-icon-x-circle
              v-else-if="locationName != '' && !noSearchThree"
              class="search1"
              style="position: absolute; right: 20px; top: 12px; cursor: pointer"
              @click="locationName = ''; noSearchThree = false"
            />
            <input
              v-model="locationName"
              type="text"
              name="search-box"
              :style="getMaterialLocationLocationNameLike && getMaterialLocationLocationNameLike.length > 0 && noSearchThree ? 'border-radius: 8px 8px 0px 0px' : ''"
              :placeholder="$t('Location')"
              @keyup="inputChanged3"
              @keydown.down="onArrowDown3"
              @keydown.up="onArrowUp3"
              @keydown.enter="inputChanged3($event)"
            >
          </div>
          <div
            v-if="getMaterialLocationLocationNameLike && getMaterialLocationLocationNameLike.length > 0 && noSearchThree"
            ref="scrollContainer3"
            class="dropdrop"
            style="
            display: inline-block;
            overflow: auto;
            position: absolute;
            background: white;
            width: 229px;
            box-shadow: none;
            "
            :style="getMaterialLocationLocationNameLike && getMaterialLocationLocationNameLike.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(item, index) in getMaterialLocationLocationNameLike"
              :key="index"
              ref="options3"
              style="cursor: pointer"
              :class="{ 'is-active': index === arrowCounter3 }"
              class="search-item"
              @click.stop="searchByLocation(item); noSearchThree = false"
            >
              <p style="margin: 0">
                {{ item.locationName || item.name || '[Error: Missing Display Key]' }}
              </p>
            </div>
          </div>
        </div>

      </div>
      <div style="width: 100%;padding-top: 16px; margin-top: 15px; height: 84vh; overflow-y: scroll;">
        <table
          ref="exportable_table"
          class="team_table"
        >
          <thead style="position: sticky; top: -18px;">
            <tr>
              <th>
                {{ $t("No") }}
              </th>
              <th>
                {{ $t('MaterialVariantsName') }}
              </th>
              <th>
                {{ $t('MaterialName') }}
              </th>
              <th>
                {{ $t('Location Name') }}
              </th>
              <th>
                {{ $t('LocationType') }}
              </th>
              <th>
                {{ $t('CurrentAmount') }}
              </th>
              <th>
                {{ $t('Notes') }}
              </th>
            </tr>
          </thead>
          <tbody v-if="getMaterialVariantlocation && getMaterialVariantlocation.length > 0">
            <tr
              v-for="(order,index) in getMaterialVariantlocation"
              :key="index"
            >
              <td>
                {{ getTotalItemsForMaterials - (page - 1) * pageSize - index }}.
              </td>
              <td>
                {{ order.materialVariantName }}
              </td>
              <td>
                {{ order.materialName }}
              </td>
              <td>
                {{ order.locationName }}
              </td>
              <td>
                {{ order.locationType }}
              </td>
              <td>
                {{ order.currentAmount }}
              </td>
              <td>
                {{ order.notes }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td
                colspan="7"
                style="padding: 9px; text-align: center;"
              >
                {{ $t('No_Colors_are_shown') }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <b-pagination
          v-if="getTotalItemsForMaterials > 15"
          v-model="page"
          :total-rows="getTotalItemsForMaterials"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          prev-class="prev-itemi"
          next-class="next-itemi"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
          </template>
          <template #next-text>
            <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      searchType: 'variant', // 'variant', 'name', 'location'
      noSearch: false,
      noSearchTwo: false,
      noSearchThree: false,
      page: 1,
      arrowCounter: 0,
      arrowCounter2: 0, 
      arrowCounter3: 0,
      enterPressed: false,
      materialVariantName: '',
      materialName: '',
      locationName: '',
      selectedLocationId: null,
      pageSize: 15,
      color: { /* ... */ },
      timeoutId: null,
    };
  },
  computed: {
    ...mapGetters([
      'getMaterialVariantlocation',
      'getMaterialVariantLocationNameLike',
      'getMaterialLocationMaterialNameLike',
      'getMaterialLocationLocationNameLike',
      'getColorsData',
      'getLoggedInUser',
      'getCurrentPageColors',
      'getTotalItemsForMaterials',
      'getColorNames',
    ]),
  },
  watch: {
    page(value) {
      if (value === 0) return;
      
      const activeMaterialVariantName = this.materialVariantName || null;
      const activeMaterialName = this.materialName || null;
      const activeLocationId = this.selectedLocationId || null; 

      this.materialVariant_location_Pagination({
          materialVariantId: null,
          materialVariantName: activeMaterialVariantName,
          materialName: activeMaterialName,
          locationId: activeLocationId,
          pageNumber: value,
          pageSize: this.pageSize,
      });
  },
      
      materialVariantName(value) {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
          if (this.searchType !== 'variant' || this.enterPressed) {
            if (value === '') {
              this.selectedLocationId = null; 
              this.materialVariant_location_Pagination({
                materialVariantId: null, materialVariantName: null, materialName: null, locationId: null, pageNumber: this.page, pageSize: this.pageSize,
              });
              this.noSearch = false;
            }
            return;
          }

          if (value !== '') {
            this.materialVariant_location_nameLike(value);
            this.noSearch = true;
          } else {
            this.materialVariant_location_Pagination({
              materialVariantId: null, materialVariantName: null, materialName: null, locationId: null, pageNumber: this.page, pageSize: this.pageSize,
            });
            this.noSearch = false;
          }
        }, 500);
      },
      
      materialName(value) {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
          if (this.searchType !== 'name' || this.enterPressed) {
             if (value === '') {
              this.selectedLocationId = null; 
              this.materialVariant_location_Pagination({
                materialVariantId: null, materialVariantName: null, materialName: null, locationId: null, pageNumber: this.page, pageSize: this.pageSize,
              });
              this.noSearchTwo = false;
            }
            return;
          }
          
          if (value !== '') {
            this.material_location_materialNameLike(value);
            this.noSearchTwo = true;
          } else {
            this.materialVariant_location_Pagination({
              materialVariantId: null, materialVariantName: null, materialName: null, locationId: null, pageNumber: this.page, pageSize: this.pageSize,
            });
            this.noSearchTwo = false;
          }
        }, 500);
      },
      
      locationName(value) {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
          if (this.searchType !== 'location' || this.enterPressed) {
             if (value === '') {
              this.selectedLocationId = null; 
              this.materialVariant_location_Pagination({
                materialVariantId: null, materialVariantName: null, materialName: null, locationId: null, pageNumber: this.page, pageSize: this.pageSize,
              });
              this.noSearchThree = false;
            }
            return;
          }

          if (value !== '') {
            this.locationNamesByNameLike(value);
            this.noSearchThree = true;
          } else {
            this.materialVariant_location_Pagination({
              materialVariantId: null, materialVariantName: null, materialName: null, locationId: null, pageNumber: this.page, pageSize: this.pageSize,
            });
            this.noSearchThree = false;
          }
        }, 500);
      },
    },
  mounted() {
    this.fetch();
  },
  methods: {
    ...mapActions([
      'changeLoadingtoTrue', 'materialVariant_location_nameLike', 'material_location_materialNameLike',
      'material_location_locationNameLike', 'locationNamesByNameLike', 
      'addColor', 'loadColors', 'colorNameLike', 'resetColorNames', 'editColor', 'materialVariant_location_Pagination']),

    async fetch() {
      await this.materialVariant_location_Pagination({
        materialVariantId: null, materialVariantName: null, materialName: null, locationId: null, pageNumber: this.page, pageSize: this.pageSize,
      });
    },
    removeLists() {
      // This is the function that closes all dropdowns when the user clicks outside.
      this.noSearch = false;
      this.noSearchTwo = false;
      this.noSearchThree = false;
      this.resetColorNames();
    },
    
    // --- Arrow Key/Input Methods ---
    onArrowDown(ev) { this.arrowCounter = (this.arrowCounter < this.getMaterialVariantLocationNameLike.length - 1) ? this.arrowCounter + 1 : this.arrowCounter; this.fixScrolling(); },
    onArrowUp(ev) { this.arrowCounter = (this.arrowCounter > 0) ? this.arrowCounter - 1 : 0; this.fixScrolling(); },
    inputChanged(event) {
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') { return; }
      if (event.code === 'Enter') {
        this.enterPressed = true;
        const selected = this.getMaterialVariantLocationNameLike[this.arrowCounter];
        const valueToSearch = selected ? selected.locationName : this.materialVariantName;
        this.searchByVariantName(valueToSearch);
        this.removeLists();
        this.arrowCounter = 0;
        setTimeout(() => { this.enterPressed = false; }, 1000);
      }
    },
    fixScrolling() {
      if (this.$refs.options && this.$refs.options.length > this.arrowCounter && this.$refs.scrollContainer) {
          const liH = this.$refs.options[this.arrowCounter].clientHeight;
          this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
      }
    },
    onArrowDown2(ev) { this.arrowCounter2 = (this.arrowCounter2 < this.getMaterialLocationMaterialNameLike.length - 1) ? this.arrowCounter2 + 1 : this.arrowCounter2; this.fixScrolling2(); },
    onArrowUp2(ev) { this.arrowCounter2 = (this.arrowCounter2 > 0) ? this.arrowCounter2 - 1 : 0; this.fixScrolling2(); },
    inputChanged2(event) {
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') { return; }
      if (event.code === 'Enter') {
        this.enterPressed = true;
        const selected = this.getMaterialLocationMaterialNameLike[this.arrowCounter2];
        const valueToSearch = selected ? selected.locationName : this.materialName;
        this.searchByName(valueToSearch);
        this.removeLists();
        this.arrowCounter2 = 0;
        setTimeout(() => { this.enterPressed = false; }, 1000);
      }
    },
    fixScrolling2() {
      if (this.$refs.options2 && this.$refs.options2.length > this.arrowCounter2 && this.$refs.scrollContainer2) {
          const liH = this.$refs.options2[this.arrowCounter2].clientHeight;
          this.$refs.scrollContainer2.scrollTop = liH * this.arrowCounter2;
      }
    },
    onArrowDown3(ev) { this.arrowCounter3 = (this.arrowCounter3 < this.getMaterialLocationLocationNameLike.length - 1) ? this.arrowCounter3 + 1 : this.arrowCounter3; this.fixScrolling3(); },
    onArrowUp3(ev) { this.arrowCounter3 = (this.arrowCounter3 > 0) ? this.arrowCounter3 - 1 : 0; this.fixScrolling3(); },
    inputChanged3(event) {
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') { return; }
      if (event.code === 'Enter') {
        this.enterPressed = true;
        const selected = this.getMaterialLocationLocationNameLike[this.arrowCounter3];
        const resultToSearch = selected || { locationName: this.locationName, locationId: null };
        this.searchByLocation(resultToSearch);
        this.removeLists();
        this.arrowCounter3 = 0;
        setTimeout(() => { this.enterPressed = false; }, 1000);
      }
    },
    fixScrolling3() {
      if (this.$refs.options3 && this.$refs.options3.length > this.arrowCounter3 && this.$refs.scrollContainer3) {
        const liH = this.$refs.options3[this.arrowCounter3].clientHeight;
        this.$refs.scrollContainer3.scrollTop = liH * this.arrowCounter3;
      }
    },
    
    setSearchType(type) {
      this.searchType = type;
      this.materialVariantName = '';
      this.materialName = '';
      this.locationName = '';
      this.selectedLocationId = null;
      this.page = 1;

      this.materialVariant_location_Pagination({
        materialVariantId: null,
        materialVariantName: null,
        materialName: null,
        locationId: null,
        pageNumber: 1,
        pageSize: this.pageSize,
      });
    },

    searchByVariantName(value) {
      this.enterPressed = true;
      const filterValue = value && typeof value === 'string' ? value : null;

      this.materialVariantName = filterValue || '';
      this.page = 1;

      this.materialName = '';
      this.locationName = '';
      this.selectedLocationId = null; 

      this.materialVariant_location_Pagination({
          materialVariantId: null,
          materialVariantName: filterValue,
          materialName: null,
          locationId: null,
          pageNumber: 1,
          pageSize: this.pageSize,
      });
      setTimeout(() => { this.enterPressed = false; }, 1000);
  },

  searchByName(value) {
      this.enterPressed = true;
      const filterValue = value && typeof value === 'string' ? value : null;

      this.materialName = filterValue || '';
      this.page = 1;

      this.materialVariantName = '';
      this.locationName = '';
      this.selectedLocationId = null;

      this.materialVariant_location_Pagination({
          materialVariantId: null,
          materialVariantName: null,
          materialName: filterValue,
          locationId: null,
          pageNumber: 1,
          pageSize: this.pageSize,
      });
      setTimeout(() => { this.enterPressed = false; }, 1000);
  },

  searchByLocation(result) {
      this.enterPressed = true;
      const selectedLocationName = (result && (result.locationName || result.name)) || null;
      const selectedLocationId = (result && (result.locationId || result.id)) || null; 

      this.locationName = selectedLocationName || '';
      this.selectedLocationId = selectedLocationId; 
      this.page = 1;

      this.materialVariantName = '';
      this.materialName = '';

      this.materialVariant_location_Pagination({
          materialVariantId: null,
          materialVariantName: null,
          materialName: null,
          locationId: selectedLocationId,
          pageNumber: 1,
          pageSize: this.pageSize,
      });
      setTimeout(() => { this.enterPressed = false; }, 1000);
  }
  },
};
</script>

<style scoped lang="scss">
.dropdrop::-webkit-scrollbar {
  display: none;
}

.team_table td {
  padding: 16px 9px !important;
}

.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: none;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}

table:hover {
  cursor: pointer;
}

.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}
.active2 {
  font-weight: bold;
}
.active2{
  font-weight: bold;
}

.search-item:hover {
  background: #82868c;
  color: white;
}

.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}

.is-active {
  background-color: #dedede;
}
</style>